import { appSettingsActions } from './app-settings.actions';
import { Action, createReducer, on } from '@ngrx/store';

export interface AppSettingsState {
  dcLastUpdatedDate: Date;
  splitIOSDKLoaded: boolean;
}

export const initialState: AppSettingsState = {
  dcLastUpdatedDate: null,
  splitIOSDKLoaded: false,
};

const appSettingsReducer = createReducer(
  initialState,
  on(
    appSettingsActions.loadDcLastUpdatedDate,
    (state) => state
  ),
  on(
    appSettingsActions.loadDcLastUpdatedDateSuccess,
    (state, action) => ({
      ...state,
      dcLastUpdatedDate: action.date
    })
  ),
  on(
    appSettingsActions.loadDcLastUpdatedDateFailure,
    (state) => state
  ),
);

export function reducer(state: AppSettingsState | undefined, action: Action): AppSettingsState {
  return appSettingsReducer(state, action);
}
